import {createSlice} from "@reduxjs/toolkit";

import {ShippingAddressSummaryFragment} from "~/api/generated";
import {VATValidationInputStateEnum} from "~/components/inputs";
import {ILocalCustomer, ILocalCustomerAddress} from "~/model/DAO/ICustomer";

import {resetAll} from "./global";

export interface CustomerState {
  localCustomer: ILocalCustomer;
  defaultAddressFromBE: ILocalCustomerAddress;
  initVATValidationInputState: VATValidationInputStateEnum | undefined;
  shouldCreateNewOnSubmit: boolean;
}

const initialState: CustomerState = {
  localCustomer: {} as ILocalCustomer,
  defaultAddressFromBE: {} as ILocalCustomerAddress,
  initVATValidationInputState: undefined,
  shouldCreateNewOnSubmit: false,
};

export const LocalCustomerSlice = createSlice({
  name: "localCustomer",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    setLocalCustomer: (state, action) => {
      const {mailingAddresses} = action.payload;
      let newLocalCustomer = {
        ...state.localCustomer,
        ...action.payload,
      };
      if (mailingAddresses)
        newLocalCustomer = {
          ...newLocalCustomer,
          mailingAddresses: mailingAddresses.map((el: ShippingAddressSummaryFragment) => ({...el})),
        };
      return {
        ...state,
        localCustomer: newLocalCustomer,
      };
    },
    resetLocalCustomer: (state) => ({
      ...state,
      localCustomer: {...initialState.localCustomer},
    }),
    toggleShouldCreateNewOnSubmit: (state) => ({
      ...state,
      shouldCreateNewOnSubmit: !state.shouldCreateNewOnSubmit,
    }),
    setDefaultAddressFromBE: (state, action) => ({
      ...state,
      defaultAddressFromBE: action.payload,
    }),
    resetDefaultAddressFromBE: (state) => {
      state.defaultAddressFromBE = initialState.defaultAddressFromBE;
    },
    setInitVATValidationInputState: (state, action) => {
      state.initVATValidationInputState = action.payload;
    },
    resetInitVATValidationInputState: (state) => {
      state.initVATValidationInputState = initialState.initVATValidationInputState;
    },
    resetCountryDependentCustomerData: (state) => {
      state.initVATValidationInputState = initialState.initVATValidationInputState;
      state.defaultAddressFromBE = initialState.defaultAddressFromBE;
    },
  },
});

export const LocalCustomerActions = LocalCustomerSlice.actions;

export default LocalCustomerSlice.reducer;
